/**
Author - Brijesh Pandey
Git - https://github.com/brijesh-pandey
**/

import React from "react";
import PropTypes from "prop-types";
import OtpVerification from "./OtpVerification";

const OtpVerificationContainer = ({
  otp,
  handleOtpChange,
  userData,
  userStep,
  inputRefs,
  handleResend,
  handleKeyDown,
  isResendingOtp
}) => (
  <OtpVerification
    handleKeyDown={handleKeyDown}
    handleOtpChange={handleOtpChange}
    handleResend={handleResend}
    inputRefs={inputRefs}
    isResendingOtp={isResendingOtp}
    otp={otp}
    userData={userData}
    userStep={userStep}
  />
);

OtpVerificationContainer.propTypes = {
  handleKeyDown: PropTypes.func,
  handleOtpChange: PropTypes.func.isRequired,
  handleResend: PropTypes.func,
  inputRefs: PropTypes.object.isRequired,
  isResendingOtp: PropTypes.bool,
  otp: PropTypes.arrayOf(PropTypes.string).isRequired,
  userData: PropTypes.object.isRequired,
  userStep: PropTypes.number.isRequired
};

export default OtpVerificationContainer;
